export const MIME_APPLICATION_OCTET_STREAM = 'application/octet-stream';
export const MIME_APPLICATION_PDF = 'application/pdf';
export const MIME_APPLICATION_ZIP = 'application/zip';
export const MIME_IMAGE_JPEG = 'image/jpeg';
export const MIME_TEXT_CSV = 'text/csv';
export const MIME_APPLICATION_VND_MS_EXCEL = 'application/vnd.ms-excel';

export const INFOS_LOGIN_PDF = 'infos-login.pdf';
export const INFOS_CEAF_PDF = 'carte-europeenne-d-armes-a-feu.pdf';
export const FICHE_SITUATION_PDF = 'fiche-situation.pdf';
